// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__r63M6","modal":"Modal_modal__DJDMv","btn-close":"Modal_btn-close__wlubt"};